<template>
  <!--page-->
  <div class="p2_bgpage p2_spage" id="app">
    <!--recall-->
    <div class="p2_srecall" v-show="showRecall">
      <!---s-s-SLOGAN-大-->
      <div class="p2_sliceSLOGANda"><img class="p2_diSLOGANda" src="../../assets/p2/images/gettitle.png"
          referrerpolicy="no-referrer" /></div>
      <!--cardimgout-->
      <div class="p2_scardimgout">
        <!---s-s-cardimg-->
        <div class="p2_slicecardimg"><img class="p2_dicardimg" :src="getCardImg" referrerpolicy="no-referrer" /></div>
      </div>
      <!--carddesc-->
      <div class="p2_bgcarddesc p2_scarddesc">
        <!---s-tx-cardtitle-->
        <div class="p2_textcardtitle">{{ getCardTitle }}</div>
        <!---s-tx-card-desc-->
        <div class="p2_textcarddesc" v-html="getCardTips"></div>
      </div>
      <!---s-bt-getbtn-->
      <div class="p2_buttongetbtn"><img class="p2_digetbtn" @click="showRecall = false; canCall = true"
          src="../../assets/p2/images/imggetbtn.png" referrerpolicy="no-referrer" /></div>
    </div>
    <!--main-->
    <div class="p2_bgmain p2_smain" v-show="!showRecall">
      <!---s-bt-audio-->
      <div class="p2_buttonaudio">
        <!-- <my-audio></my-audio> -->
      </div>
      <!---s-s-SLOGAN-大-->
      <div class="p2_sliceSLOGANda_1"><img class="p2_diSLOGANda_1" src="../../assets/p2/images/imgSLOGAN-da.png"
          referrerpolicy="no-referrer" /></div>
      <!--tasks-->
      <div class="p2_bgtasks p2_stasks">
        <img style="display: none;" src="../../assets/p2/images/imgtaskget.png" referrerpolicy="no-referrer" />
        <img style="display: none;" src="../../assets/p2/images/imgtaskgot.png" referrerpolicy="no-referrer" />
        <img style="display: none;" src="../../assets/p2/images/imgtaskjoin.png" referrerpolicy="no-referrer" />
        <!--task1-->
        <div class="p2_bgtask1 p2_stask1">
          <!---s-bt-taskget-->
          <div class="p2_buttontaskget">
            <img class="p2_ditaskget" src="../../assets/p2/images/imgtaskget.png" @click="reward(0)"
              referrerpolicy="no-referrer" v-if="task1Status == 1" />
            <img class="p2_ditaskget" src="../../assets/p2/images/imgtaskgot.png" referrerpolicy="no-referrer"
              v-else-if="task1Status == 2" />
            <img class="p2_ditaskget" src="../../assets/p2/images/imgtaskjoin.png" @click="join(0)"
              referrerpolicy="no-referrer" v-else />
          </div>
          <!---s-tx-task1t1-->
          <div class="p2_texttask1t1">登录本活动页面({{ loginTimes }}/1)</div>
          <!---s-tx-task1t2-->
          <div class="p2_texttask1t2">召唤次数x1</div>
        </div>
        <!--task2-->
        <div class="p2_bgtask2 p2_stask2">
          <!---s-bt-taskgot-->
          <div class="p2_buttontaskgot">
            <img class="p2_ditaskget" src="../../assets/p2/images/imgtaskget.png" @click="reward(1)"
              referrerpolicy="no-referrer" v-if="task2Status == 1" />
            <img class="p2_ditaskget" src="../../assets/p2/images/imgtaskgot.png" referrerpolicy="no-referrer"
              v-else-if="task2Status == 2" />
            <img class="p2_ditaskget" src="../../assets/p2/images/imgtaskjoin.png" @click="join(1)"
              referrerpolicy="no-referrer" v-else />
          </div>
          <!---s-tx-task2t1-->
          <div class="p2_texttask2t1">浏览TapTap论坛({{ viewTapTimes }}/1)</div>
          <!---s-tx-task2t2-->
          <div class="p2_texttask2t2">召唤次数x3</div>
        </div>
        <!--task3-->
        <div class="p2_bgtask3 p2_stask3">
          <!---s-bt-taskjoin-->
          <div class="p2_buttontaskjoin">s
            <img class="p2_ditaskget" src="../../assets/p2/images/imgtaskget.png" @click="reward(2)"
              referrerpolicy="no-referrer" v-if="task3Status == 1" />
            <img class="p2_ditaskget" src="../../assets/p2/images/imgtaskgot.png" referrerpolicy="no-referrer"
              v-else-if="task3Status == 2" />
            <img class="p2_ditaskget" src="../../assets/p2/images/imgtaskjoin.png" @click="join(2)"
              referrerpolicy="no-referrer" v-else />
          </div>
          <!---s-tx-task3t1-->
          <div class="p2_texttask3t1">送出1张插画(无限制)</div>
          <!---s-tx-task3t2-->
          <div class="p2_texttask3t2">召唤次数x1</div>
        </div>
        <!--task4-->
        <div class="p2_bgtask4 p2_stask4">
          <!---s-bt-join-->
          <div class="p2_buttonjoin">
            <img class="p2_ditaskget" src="../../assets/p2/images/imgtaskget.png" @click="reward(3)"
              referrerpolicy="no-referrer" v-if="task4Status == 1" />
            <img class="p2_ditaskget" src="../../assets/p2/images/imgtaskgot.png" referrerpolicy="no-referrer"
              v-else-if="task4Status == 2" />
            <img class="p2_ditaskget" src="../../assets/p2/images/imgtaskjoin.png" @click="join(3)"
              referrerpolicy="no-referrer" v-else />
          </div>
          <!---s-tx-task4t1-->
          <div class="p2_texttask4t1">当日送出2张插画({{ sendCardNum }}/2)</div>
          <!---s-tx-task4t2-->
          <div class="p2_texttask4t2">自选插画x1</div>
        </div>
        <div style="position: absolute; top:3.56rem; width: 100%; text-align: right; font-size: .22rem; color: rgba(69,39,25,1);">*04:00刷新任务</div>
      </div>
      <!--中部-->
      <div class="p2_bgzhongb p2_szhongb">
        <!--huanxingbtns-->
        <div class="p2_shuanxingbtns">
          <!---s-bt-hanxing-->
          <div class="p2_buttonhanxing" v-if="leftTimes > 0"><img class="p2_dihanxing" @click="call"
              src="../../assets/p2/images/imghanxing.png" referrerpolicy="no-referrer" /></div>
          <!---s-bt-huanxinggray-->
          <div class="p2_buttonhuanxinggray" v-else><img class="p2_dihuanxinggray"
              src="../../assets/p2/images/imghuanxinggray.png" referrerpolicy="no-referrer" /></div>
          <!--lefttimes-->
          <div class="p2_bglefttimes p2_slefttimes">
            <!---s-tx-剩余次数:-0-->
            <div class="p2_textshengycs0">剩余次数: {{ leftTimes }}</div>
          </div>
        </div>
      </div>
      <!--bar-->
      <bar :value="2"></bar>
    </div>
    <!---s-dg-selcarddg-->
    <van-popup class="p2_bgselcarddg p2_dialogselcarddg" :close-on-click-overlay="false" v-bind:value="popselcarddg">
      <!---s-s-上遮罩-->
      <div class="p2_sliceshangzz"><img class="p2_dishangzz" src="../../assets/p2/images/imgshangzz.png"
          referrerpolicy="no-referrer" /></div>
      <!---s-bt-X-->
      <div class="p2_buttonX"><img class="p2_diX" src="../../assets/p2/images/imgX.png" @click="popselcarddg = false"
          referrerpolicy="no-referrer" /></div>
      <!---s-s-selcardtitle-->
      <div class="p2_sliceselcardtitle"><img class="p2_diselcardtitle" src="../../assets/p2/images/imgselcardtitle.png"
          referrerpolicy="no-referrer" /></div>
      <!--cards-->
      <div class="p2_scards">
        <!--01-->
        <div class="p2_s01" v-for="(item, index) in cards" v-bind:key="index">
          <!---s-s-cardimgsel-->
          <div class="p2_slicecardimgsel">
            <img class="p2_dicardimgsel" @click="selectCard(item)" :src="item.img" v-if="item.own > 0"
              referrerpolicy="no-referrer" />
            <img class="p2_dicardimgsel p2_dicardimgsel_tran" @click="selectCard(item)" :src="item.img" v-else
              referrerpolicy="no-referrer" />
          </div>
          <!---s-s-selected-->
          <div class="p2_sliceselected" v-if="item.selected"><img class="p2_diselected"
              src="../../assets/p2/images/imgselected.png" referrerpolicy="no-referrer" /></div>
          <!---s-tx-havecard-->
          <div class="p2_texthavecard">已拥有: {{ item.own }}</div>
        </div>
      </div>
      <!---s-s-下遮罩-->
      <div class="p2_slicexiazz"><img class="p2_dixiazz" src="../../assets/p2/images/imgxiazz.png"
          referrerpolicy="no-referrer" /></div>
      <!---s-bt-exchangebtn-->
      <div class="p2_buttonexchangebtn"><img class="p2_diexchangebtn" @click="exchange"
          src="../../assets/p2/images/imgexchangebtn.png" referrerpolicy="no-referrer" /></div>
    </van-popup>
    <login-bind ref="loginBind" @login="checkBind" @bind="checkBind"></login-bind>
    <common-alert ref="alert"></common-alert>
    <show-err ref="errObj"></show-err>
  </div>
</template>

<style lang="css" scoped>
@import '../../assets/p2/css/s2.css';
</style>

<script src="//r2cdn-game.r2games.com.cn/gamesite/myheroes/4thac/time/js/jquery-1.11.0.min.js"></script>
<script>
import {timeLessFinishTaptap, timeLessGetTaskAward, timeLessLottery} from "@/api/apis";

function showEffect() {
  // $(".p2_scardimgout").addClass("bgcardimgout")
  $(".p2_scarddesc").hide()
  let width = $(".p2_dicardimg").width()
  $(".p2_dicardimg").css("left", parseInt(-width / 2) + "px")
  $(".p2_slicecardimg").css("left", parseInt(width / 2) + "px").css("width", 0)
  $(".p2_dicardimg").animate({left: 0}, 600)
  $(".p2_slicecardimg").animate({width: width + "px", left: 0}, 600, function () {
        $(".p2_scarddesc").fadeIn(800)
      }
  )
}

import Vue from 'vue'
import {Popup} from 'vant'
import Bar from '@/components/bar/index.vue'
// import MyAudio from '@/components/audio/index.vue'
import LoginBind from '@/components/loginbind/index'
import ShowErr from '@/components/showerr/index'
import CommonAlert from "@/components/commonalert";
import info from '@/api/states/info'
import cardConfig from '@/api/states/cardconfig'

Vue.use(Popup)

export default {
  name: 'Memory',
  components: {
    Bar,
    // MyAudio,
    LoginBind,
    ShowErr,
    CommonAlert
  },
  data() {
    return {
      popselcarddg: false,
      task1Status: 0, // 0-未完成，1-可领取，2-已领取
      task2Status: 0,
      task3Status: 0,
      task4Status: 0,
      loginTimes: 0, // 登录本活动次数
      viewTapTimes: 0, // 浏览tap次数
      sendCardNum: 0, // 赠送插画数量
      leftTimes: 0, // 剩余召回次数
      cards: [],
      selectedCard: null,
      showRecall: false,
      getCardImg: "",
      getCardTitle: "",
      getCardTips: "",
      loginBind: null,
      errObj: null,
      hasInfo: false,
      alertObj: null,
      canCall: true,
    };
  },
  mounted() {

    info.getTime()
    
    document.getElementsByClassName("p2_buttonaudio")[0].appendChild(this.$myAudio.$el);

    this.loginBind = this.$refs["loginBind"]
    this.errObj = this.$refs["errObj"]
    this.alertObj = this.$refs["alert"]

    for (let i = 0; i < cardConfig.length; i ++) {
      this.cards.push({
        id: i,
        own: 0,
        img: cardConfig[i].img,
        title: cardConfig[i].title,
        tips: cardConfig[i].tips,
        selected: false
      })
    }

    this.checkBind(false)
  },
  methods: {
    async checkBind(showDialog = false) {
      try {
        let loginStatus = await this.loginBind.check(showDialog)
        const infoStatus = await info.getInfo()
        if (infoStatus) {
          this.getTimeLessInfo()
        }

        return loginStatus

      } catch (error) {
        if (showDialog) {
          this.errObj.showErr(error)
        }
        console.log(error)
      }

      return false
      // if (this.hasInfo) {
      //   return true
      // }
      // if (!userInfo.isLogin) {
      //   let binded = false
      //   await getUserInfo().then(res => {
      //     console.log(res)
      //     if (res.code === 0) {
      //       setUserInfo(res)
      //       this.getTimeLessInfo()
      //       binded = userInfo.isBind
      //     } else if (res.code === 2) {
      //       if (showDialog) {
      //         this.loginBind.showLogin()
      //       }
      //     } else {
      //       this.errObj.showErr(res.message)
      //     }
      //   }).catch(err => {
      //     console.log(err)
      //   })

      //   console.log(binded)
      //   return binded
      // } else {
      //   this.getTimeLessInfo()
      //   if (!userInfo.isBind) {
      //     if (showDialog) {
      //       this.loginBind.showBind()
      //     }
      //     return false
      //   }
      // }

      // return true
    },
    getTimeLessInfo() {

      this.task1Status = info.taskInfo[0]
      this.task2Status = info.taskInfo[1]
      this.task3Status = info.taskInfo[2]
      this.task4Status = info.taskInfo[3]

      this.loginTimes = this.task1Status == 2 ? 1 : 0
      this.viewTapTimes = this.task2Status == 2 ? 1 : 0
      this.sendCardNum = info.daySendTimes

      // cards
      for (let i = 0; i < info.cardInfo.length; i++) {
        this.cards[i]["own"] = info.cardInfo[i]
      }

      this.leftTimes = info.times
    },
    getStatus(taskId) {

      let status = 0
      switch (taskId) {
        case 0:
          status = this.task1Status
          break
        case 1:
          status = this.task2Status
          break
        case 2:
          status = this.task3Status
          break
        case 3:
          status = this.task4Status
          break
      }

      return status
    },
    async reward(taskId) {
      if (taskId == 4) {
        return; // in exchange
      }
      let status = this.getStatus(taskId)
      if (status != 1) {
        return
      }

      if (!await this.checkBind(true)) {
        return
      }

      // check 活动结束
      if (!this.alertObj.checkEnd()) {
        return
      }

      if (taskId == 3) {
        // 自选插画
        this.popselcarddg = true
        return;
      }

      // request
      timeLessGetTaskAward(taskId, 0).then(res => {
        console.log(res)
        if (res.code !== 0) {
          this.errObj.showErr(res.message)
        } else {
          this.errObj.showErr("领取成功", true)
          info.getInfo(true).then(() => {
            this.getTimeLessInfo()
          })
          // })
          // if (taskId == 0) {
          //   this.task1Status = 2
          //   info.taskInfo[0] = 2
          // } else if (taskId == 1) {
          //   this.task2Status = 2
          //   info.taskInfo[1] = 2
          // } 
          // this.getTimeLessInfo()
        }
      }).catch(err => {
        this.errObj.showErr(err)
        throw err
      })
    },
    async join(taskId) {
      let checkBindStatus = await this.checkBind(true)
      console.log("check bind", checkBindStatus)
      if (!checkBindStatus) {
        return;
      }

      let status = this.getStatus(taskId)
      if (status != 0) {
        return
      }

      // check 活动结束
      if (!this.alertObj.checkEnd()) {
        return
      }

      if (taskId == 1) {
        // request
        timeLessFinishTaptap().then(res => {
          if (res.code !== 0) {
            this.errObj.showErr(res.message)
          } else {
            this.task2Status = 1
            // taptap论坛
            window.location.href = 'https://www.taptap.cn/app/77796'
          }
        }).catch(err => {
          this.errObj.showErr(err)
          throw err
        })
      } else if (taskId == 2 || taskId == 3) {
        // 送插画
        this.$router.push("/illustration");
      }
    },
    async call() {
      if (!this.canCall) {
        return
      }
      if (!await this.checkBind(true)) {
        return;
      }

      if (this.leftTimes <= 0) {
        return
      }

      // check 活动结束
      if (!this.alertObj.checkEnd()) {
        return
      }

      // request
      this.canCall = false
      timeLessLottery().then(res => {
        console.log(res)
        if (res.code !== 0) {
          this.errObj.showErr(res.message)
          this.canCall = true
        } else {
          info.times --
          info.cardInfo[res.data]++
          this.leftTimes-- // TODO 要不要请求接口重新获取？

          let item = this.cards[res.data]
          item.own++
          this.$set(this.cards, res.data, item)
          1
          this.getCardImg = item.img
          this.getCardTitle = item.title
          this.getCardTips = item.tips

          this.showRecall = true
          showEffect()
        }
      }).catch(err => {
        this.canCall = true
        this.errObj.showErr(err)
        throw err
      })
    },
    selectCard(item) {
      for (let i = 0; i < this.cards.length; i++) {
        this.cards[i].selected = false
      }
      item.selected = true
      this.selectedCard = item
    },
    exchange() {
      if (this.selectedCard == null) {
        this.errObj.showErr("请选择要兑换的插画")
        return
      }

      // check 活动结束
      if (!this.alertObj.checkEnd()) {
        return
      }

      // request
      timeLessGetTaskAward(3, this.selectedCard.id).then(res => {
        console.log(res)
        if (res.code == 0) {
          this.errObj.showErr("领取成功", true)
          this.popselcarddg = false

          info.getInfo(true).then(() => {
            this.getTimeLessInfo()
          })
        } else {
          this.errObj.showErr(res.message)
        }
      }).catch(err => {
        this.errObj.showErr(err)
        throw err
      })
    }
  },
};
</script>
<style scoped>
.p2_bgpage {
  background-size: 100% auto;
}

.p2_spage {
  height: 100vh;
  min-height: 13.34rem;
}

.p2_texttask1t1 {
  width: 2.8rem;
}

.p2_texttask2t1 {
  width: 2.8rem;
}

.p2_texttask3t1 {
  width: 2.8rem;
}

.p2_texttask4t1 {
  width: 2.8rem;
}

.p2_texttask1t2 {
  width: 1.8rem;
}

.p2_texttask2t2 {
  width: 1.8rem;
}

.p2_texttask3t2 {
  width: 1.8rem;
}

.p2_texttask4t2 {
  width: 1.8rem;
}

.p2_scards {
  width: 6.7rem;
  height: 7.44rem;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-bottom: 0.8rem;
}

.p2_scards::-webkit-scrollbar {
  width: 0.1rem;
}

.p2_scards::-webkit-scrollbar-thumb {
  background-color: #a18f84;
}

.p2_s01 {
  float: left;
  width: 3.3rem;
}

.p2_dicardimgsel {
  width: 3.3rem;
}

.p2_textcardtitle {
  width: 100%;
  text-align: center;
  margin-left: 0;
}

.p2_textcarddesc {
  line-height: 0.6rem;
  width: 6.768rem;
}

.p2_slicecardimg {
  position: relative;
  overflow: hidden;
  height: 5.15rem;
}

.p2_scardimgout {
  height: 5.15rem;
  top: 2.3rem;
}

.p2_dicardimg {
  position: absolute;
  height: 5.15rem;
}

.p2_sliceshangzz {
  pointer-events: none;
}

.p2_slicexiazz {
  pointer-events: none;
}

.p2_szhongb {
  top: max(1.96rem, calc(1.96rem + (100vh - 13.34rem)/2));
}
.p2_dicardimgsel_tran {
  opacity: 0.6;
}
.p2_textshengycs0 {
  width: 100%;
  text-align: center;
  margin-left: 0;
}
.p2_texthavecard {
  width: 2.1rem;
  left: 0.72rem;
  text-align: center;
}
.p1_sbar {
  top: max(11.38rem, calc(100vh - 0.34rem - 1.35rem - 0.28rem));
  left: 0;
}
.p2_dialogselcarddg {
  position: fixed;
}
</style>